import { Injectable, NgZone } from "@angular/core";
import { NavigationEnd, NavigationExtras, Router } from "@angular/router";
import { Subject } from "rxjs";
import { GET_WALLET_TRANSACTION, USER_STATUS_FOR_CALL_CHAT } from "./payload";
import { HttpService } from "./http.service";
import { ToastrService } from "ngx-toastr";

@Injectable({
  providedIn: "root",
})
export class GlobalService {
  userFullName: any;
  userName: any;
  userMobileNo: any;
  userBalance: number = 0;
  userData: any = null;
  currencySign: string = "₹";
  currencyType: string = "INR";
  timeZone: string = "Asia/Kolkata";
  indiaZone: boolean = true;
  projectId: number = 5;
  PlatformType: string = "WEBSITE";
  customerId: any = 0;

  appVersion: string = "1.0.0";
  platformType: string = "WEBSITE";
  notificationId: any = null;
  LoggedUserData: any;

  profilePicture: any;
  showChatStrip:boolean=true;

  authTokenId: any;
  isUserLoggedin: boolean = false;

  chatStripData: any = null;

  concernArea: Array<any> = [
    { name: "Legal Consultation" },
    { name: "Tax Filling" },
    { name: "Business Registration" },
    { name: "Licensing" },
    { name: " Copyright & Trademark" },
    { name: "Other" },
  ];

  private commonListner = new Subject<void>();
  commonListnerRefresh = this.commonListner.asObservable();

  private listnerForDownloadPopup = new Subject<void>();

  listnerForDownloadPopupRefresh = this.listnerForDownloadPopup.asObservable();
  triggerCommonListner(data: any): void {
    this.commonListner.next(data);
  }

  indiaTimezone: boolean = true;

  constructor(
    public router: Router,
    public toastCtrl: ToastrService,
    private zone: NgZone
  ) {
    this.isUserLoggedin = !!localStorage.getItem("userData");

    this.userData = this.getUserDataFromStorage();
    this.customerId = this.userData?.id ? this.userData?.id : 0;

    console.log("userData", this.userData);
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0);
      }
    });

    console.log(this.userData);

    this.userName = this.userData?.name;
  }

  getTimeZone() {
    return new Promise((resolve, reject) => {
      if (this.userData !== null && this.userData !== "undefined") {
        if (this.userData?.timeZone) {
          this.timeZone = this.userData?.timeZone;
          resolve(this.timeZone);
        } else {
          const timezoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;
          let timezone = timezoneName;

          if (timezone) {
            this.timeZone = timezone;
            resolve(this.timeZone);
          }
        }
      } else {
        const timezoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;
        let timezone = timezoneName;
        if (timezone) {
          this.timeZone = timezone;
          resolve(this.timeZone);
        }
      }
    });
  }

  detectTimeZone() {
    let timeZoneDeduct = Intl.DateTimeFormat().resolvedOptions().timeZone;
    console.log("currentTime Zone", timeZoneDeduct);
    if (timeZoneDeduct == "Asia/Calcutta") {
      timeZoneDeduct = "Asia/Kolkata";
    }
    this.timeZone = timeZoneDeduct;
  }

  moveToNext(currentInput: HTMLInputElement, nextInput: HTMLInputElement) {
    if (currentInput.value.length === 1 && nextInput) {
      nextInput.focus();
    }
  }

  moveToPrev(currentInput: HTMLInputElement, prevInput: HTMLInputElement) {
    if (currentInput.value.length === 0 && prevInput) {
      prevInput.focus();
    }
  }

  getUserDataFromStorage() {
    const data = localStorage.getItem("userData");
    return data ? JSON.parse(data) : null;
  }

  LogoutUser() {
    localStorage.clear();
    this.isUserLoggedin = false;
    this.navigate("");
    this.isUserLoggedin = false;
    location.reload();
  }

  navigate(route: string) {
    this.router.navigate([route]);
  }

  converMilliSecondWithPromise(str: any) {
    return new Promise((resolve, reject) => {
      let date = new Date(str);
      let millisecond = date.getTime();
      resolve(millisecond);
    });
  }

  getUserLogginStatus() {
    return new Promise((resolve, reject) => {
      let userData = localStorage.getItem("userData")!;
      if (userData !== null && userData !== "undefined") {
        resolve(true);
      } else {
        resolve(false);
      }
    });
  }

  navigateWithExtras(route: string, extras: NavigationExtras) {
    this.zone.run(() => {
      this.router.navigate([route], extras);
    });
  }

  getNavigationExtras() {
    return this.router.getCurrentNavigation()?.extras?.state;
  }
}
